import { API_URL } from "env";

export interface ProductGroupItem {
    id: number;
    name: string;
    is_active: number;
    position: number;
    slug: string;
    short_content: string | null;
    avatar: string;
    seo_page: string;
    created_at: string;
}
async function getProductGroupList() : Promise<ProductGroupItem[]> {
    try {
        const response = await fetch(`${API_URL}/api/v1/fe/product_groups?limit=100`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (!data.status) {
            throw new Error('Failed to fetch product groups');
        }
        return data.data.items || [];
    } catch (error) {
        console.error("Error fetching product groups:", error);
        throw error;
    }
}

export {
    getProductGroupList,
}